import tw, { styled } from 'twin.macro';

export const TableWrapper = styled.figure<{
  tableWidth?: string | null;
  hideHeaderRow?: 'hide' | null;
}>`
  ${tw`mb-[46px]`}

  ${tw`overflow-x-auto`}

  ${({ tableWidth }) =>
    tableWidth === 'full_width' &&
    `
      width: calc(100% + 32px); /* Account for padding */
      margin-left: -16px;
      margin-right: -16px;

    @media (min-width: 500px) {
      max-width: 1120px;
      // 500px content width + 16px padding on each side, so that in between 500px and 720px the content doesn't overflow the viewport by 16px. 
      width: calc(100% + (100vw - 516px));
      margin-left: calc((516px - 100vw) / 2);
      margin-right: calc((516px - 100vw) / 2);
    }

    @media (min-width: 720px) {
      max-width: 1120px;
      width: calc(100% + (100vw - 736px));
      margin-left: calc((736px - 100vw) / 2);
      margin-right: calc((736px - 100vw) / 2);
    }

    @media (min-width: 1120px) {
      margin-left: calc((736px - 1120px) / 2);
      margin-right: calc((736px - 1120px) / 2);
      width: 1120px;
    }
  `}

  table {
    ${tw`w-full`}
  }

  tr {
    ${tw`border-neutrals-n5 border-b`}
    ${tw`table-row`}
    &:first-of-type {
      ${({ hideHeaderRow }) => hideHeaderRow === 'hide' && tw`hidden`}
      ${tw`text-body-s text-secondary-s1`}
      // Request from Kenny to increase the font weight for the Table headers only. 
      ${tw`font-[700]`}
      ${tw`tracking-extra`}
      ${tw`border-b-4`}
      td {
        ${tw`pb-2`}
      }
      p {
        font-size: inherit;
        line-height: inherit;
        font-weight: inherit;
        color: inherit;
        ${tw`m-0`}
      }

      strong {
        font-weight: inherit;
      }
    }

    &:not(:first-of-type) {
      ${({ hideHeaderRow }) => hideHeaderRow === 'hide' && tw`border-neutrals-n5 border-t`}
      ${tw`py-[12px] md:py-0`}

      td {
        ${tw`md:py-3`}
        ${tw`text-primary-p1`}
        ${tw`text-body-l`}
        ${tw`align-top`}

        &:first-of-type {
          ${tw`mb-[4px] md:mb-0`}
        }

        p {
          ${tw`text-primary-p1`}
        }
      }
    }
  }

  td {
    ${tw`break-words`}
    ${tw`p-2`}
    &:not(:last-of-type) {
      ${tw`md:pr-3`}
    }
    figure {
      ${tw`m-0`}
    }
  }
`;

export const StyledFigCaption = styled.figcaption`
  ${tw`px-2`}
  ${tw`mb-2 mt-2`}
  ${tw`text-body-s text-neutrals-n6`}
  ${tw`font-inter font-medium`}
`;
